<ng-container *ngIf="totalRows == 0">
    <div class="no-data">{{ noDataFoundMsg }}</div>
</ng-container>
<ng-container *ngIf="totalRows > 0">
    <!--
            appDebounceMouseMove
            [debounceTime]="10"
            (debounceMouseMove)="onListResize($event)" -->
    <div *ngIf="isTable" #tableHeader class="table-header"
        [ngClass]="{ 'below-header-and-top-bar' : parentScroll == null }" (mouseup)="onListResizeEnd($event)"
        (mouseenter)="onListHeaderMouseEnter($event)" (mouseleave)="onListHeaderMouseLeave($event)"
        (mousemove)="onListResize($event)">
        <fieldset class="table-header-fieldset">
            <mat-checkbox *ngIf="selectionTypeForActions !== SELECTION_TYPE_FOR_ACTIONS.None" #selectAllCB
                class="pull-left flip row-selection" type="checkbox" [ngStyle]="{
                        visibility:
                            selectionTypeForActions == SELECTION_TYPE_FOR_ACTIONS.Single || (selectionTypeForActions == SELECTION_TYPE_FOR_ACTIONS.Multi && hideAllSelectionInMulti) ? 'hidden' : 'visible'
                    }"
                [indeterminate]="isAllSelected ? unSelectedItems.size > 0 && unSelectedItems.size < totalRows : (selectedItems.size > 0 && !getIsAllSelectedForActions())"
                [disabled]="disabled || selectionTypeForActions === SELECTION_TYPE_FOR_ACTIONS.Single"
                [checked]="getIsAllSelectedForActions()" (change)="selectAllItemsForActions($event)"></mat-checkbox>
            <fieldset>
                <div *ngFor="let field of uiControl?.ControlFields; let j = index" class="header-column pull-left flip"
                    [ngStyle]="{ width: field.calcTitleColumnWidthString }" [ngClass]="{
                            'support-sorting': supportSorting,
                            'has-sorting': field.ApiName === sortBy,
                            'is-resizing': field.ApiName === pressedColumn,
                            'is-first': j === 0 && selectionTypeForActions !== SELECTION_TYPE_FOR_ACTIONS.Multi,
                            'is-last': j === uiControl?.ControlFields?.length - 1
                        }"
                    (click)="supportSorting ? (onListSortingChange(field.ApiName, sortBy !== null && sortBy != field.ApiName ? true : !isAsc, $event)) : false">

                    <label *ngIf="field.Title != ''" id="{{ field.ApiName }}"
                        class="header-label body-sm pull-left flip text-align-{{ field.Layout.XAlignment }}"
                        title="{{ field.Title }}">
                        {{ field.Title }}
                    </label>
                    <!-- (click)="onListSortingChange(field.ApiName, sortBy !== null && sortBy != field.ApiName ? true : !isAsc)" -->
                    <label *ngIf="field.Title == ''" id="{{ field.ApiName }}"
                        class="header-label body-sm pull-left flip">&nbsp;</label>

                    <div *ngIf="supportResizing" class="resizeBox pull-right flip"
                        (mousedown)="onListResizeStart($event, field.ApiName)">
                        <mat-icon>
                            <pep-icon name="arrow-up" class="asc">
                            </pep-icon>
                            <!-- <svg class="svg-icon asc">
                                <use attr.xlink:href="{{ userService.svgIcons }}arrow-up"></use>
                            </svg> -->
                        </mat-icon>
                    </div>

                    <!-- The onListSortingChange moved to the column click -->
                    <!-- (click)="onListSortingChange(field.ApiName, true)" -->
                    <div *ngIf="supportSorting" class="sortingBox pull-left flip"
                        [ngClass]="{ 'has-sorting': field.ApiName === sortBy }">
                        <mat-icon *ngIf="field.ApiName !== sortBy">
                            <pep-icon name="arrow-either" class="asc">
                            </pep-icon>
                            <!-- <svg class="svg-icon asc">
                                <use attr.xlink:href="{{ userService.svgIcons }}arrow-either"></use>
                            </svg> -->
                        </mat-icon>

                        <mat-icon *ngIf="field.ApiName === sortBy && !isAsc"
                            [ngClass]="{ 'sort-by': field.ApiName === sortBy && isAsc }"
                            title="{{ 'Asc' | translate }}">
                            <pep-icon name="arrow-down" class="asc">
                            </pep-icon>
                            <!-- <svg class="svg-icon asc">
                                <use attr.xlink:href="{{ userService.svgIcons }}arrow-down"></use>
                            </svg> -->
                        </mat-icon>
                        <mat-icon *ngIf="field.ApiName === sortBy && isAsc"
                            [ngClass]="{ 'sort-by': field.ApiName === sortBy && !isAsc }"
                            title="{{ 'Desc' | translate }}">
                            <pep-icon name="arrow-down" class="desc">
                            </pep-icon>
                            <!-- <svg class="svg-icon desc">
                                <use attr.xlink:href="{{ userService.svgIcons }}arrow-down"></use>
                            </svg> -->
                        </mat-icon>
                    </div>
                </div>
            </fieldset>
        </fieldset>
    </div>

    <virtual-scroll *ngIf="useVirtualScroll" [totalRows]="totalRows" [isTable]="isTable" (load)="onListLoad($event)"
        (change)="onListChange($event)" [parentScroll]="parentScroll ? parentScroll : nativeWindow"
        [bufferAmount]="isReport ? (isTable ? 20 : 3) : isTable ? 15 : 3"
        [ngClass]="{ 'table-body': isTable, 'cards-body': !isTable }">
        <ng-container *ngTemplateOutlet="listData"></ng-container>
    </virtual-scroll>

    <!-- <virtual-scroller *ngIf="useVirtualScroll" [totalItems]="totalRows" (vsChange)="onScrollerListChange($event)"
        [parentScroll]="parentScroll ? parentScroll : nativeWindow"
        [ngClass]="{ 'table-body': isTable, 'cards-body': !isTable }">
        <ng-container *ngTemplateOutlet="listData"></ng-container>
    </virtual-scroller> -->

    <div #noVirtualScrollCont *ngIf="!useVirtualScroll" [ngClass]="{ 'table-body': isTable, 'cards-body': !isTable }">
        <ng-container *ngTemplateOutlet="listData"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="listTotals"></ng-container>
</ng-container>

<!-- <img style="display:none;" src="{{ envVariables.AssetsDomain + webappDirectory }}/assets/images/no-image.svg" /> -->

<ng-template #listData>
    <ng-container *ngFor="let pepperiObjectInput of scrollItems; let index; let isFirst = first; trackBy: trackByFunc">
        <ng-container *ngIf="isTable">
            <div class="table-row"
                (mouseenter)="onTableRowMouseEnter($event, pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.Type)"
                (mouseleave)="onTableRowMouseLeave($event, pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.Type)"
                [ngClass]="{
                        selected: isItemSelected(pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.Type),
                        highlighted: pepperiObjectInput?.Data?.UID + SEPARATOR + pepperiObjectInput?.Data?.Type === selectedItemId
                    }"
                [ngStyle]="{ height: calculatedObjectHeight, visibility: showItems || pepperiObjectInput ? 'visible' : 'hidden' }">
                <fieldset class="table-row-fieldset"
                    [ngStyle]="{ 'background-color': pepperiObjectInput?.Data?.BackgroundColor }">
                    <mat-checkbox
                        *ngIf="selectionTypeForActions == SELECTION_TYPE_FOR_ACTIONS.Multi || selectionTypeForActions == SELECTION_TYPE_FOR_ACTIONS.SingleAction"
                        type="checkbox" class="pull-left flip row-selection"
                        [disabled]="getIsDisabled(pepperiObjectInput)" [ngStyle]="{
                                visibility: isTouchDevice ||
                                    pepperiObjectInput?.Data?.UID + SEPARATOR + pepperiObjectInput?.Data?.Type === hoveredItemId || isAllSelected || selectedItems.size > 0 ? 'visible' : 'hidden'
                            }"
                        [checked]="getIsSelectedForActions(pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.IsSelectableForActions, pepperiObjectInput?.Data?.Type)"
                        (change)="selectItemForActions($event, pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.IsSelectableForActions, pepperiObjectInput?.Data?.Type)">
                    </mat-checkbox>
                    <mat-radio-button *ngIf="selectionTypeForActions == SELECTION_TYPE_FOR_ACTIONS.Single"
                        name="selection" class="pull-left flip row-selection pepperi-radio-button"
                        [disabled]="getIsDisabled(pepperiObjectInput)"
                        [checked]="getIsSelectedForActions(pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.IsSelectableForActions, pepperiObjectInput?.Data?.Type)"
                        (change)="selectItemForActions($event, pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.IsSelectableForActions, pepperiObjectInput?.Data?.Type)">
                    </mat-radio-button>
                    <pep-form [checkForChanges]="checkForChanges" [uiControlHeader]="uiControl"
                        [firstFieldAsLink]="firstFieldAsLink" [pepperiObjectInput]="pepperiObjectInput"
                        [canEditObject]="!disabled && pepperiObjectInput?.IsEditable" [objectId]="objectId"
                        [parentId]="parentId" [searchCode]="searchCode" [lockEvents]="disableSelectionItems"
                        [isReport]="isReport" [layoutType]="LAYOUT_TYPE.PepperiTable" [listType]="listType" [isActive]="
                                (pepperiObjectInput?.Data?.UID + SEPARATOR + pepperiObjectInput?.Data?.Type === selectedItemId ||
                                pepperiObjectInput?.Data?.UID + SEPARATOR + pepperiObjectInput?.Data?.Type === hoveredItemId) && !isTouchDevice
                            " (notifyValueChanged)="onValueChanged($event)"
                        (notifyFieldClicked)="onCustomizeFieldClick($event)"
                        (notifyMenuItemClicked)="onCustomizeFieldMenuClicked($event)"
                        (click)="itemClicked($event, pepperiObjectInput)" [pageType]="pageType">
                    </pep-form>
                </fieldset>
            </div>
        </ng-container>

        <ng-container *ngIf="!isTable">
            <div [class]="itemClass"
                (mouseenter)="onCardMouseEnter($event, pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.Type)"
                (mouseleave)="onCardMouseLeave($event, pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.Type)"
                [ngClass]="{
                        selected: isItemSelected(pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.Type),
                        highlighted: pepperiObjectInput?.Data?.UID + SEPARATOR + pepperiObjectInput?.Data?.Type === selectedItemId,
                        cardView: isCardView
                    }" class="pull-left flip"
                [ngStyle]="{ height: calculatedObjectHeight, visibility: showItems || pepperiObjectInput ? 'visible' : 'hidden' }">
                <mat-checkbox *ngIf="showSelection" class="pull-left flip card-selection"
                    [disabled]="getIsDisabled(pepperiObjectInput)"
                    [checked]="getIsSelectedForActions(pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.IsSelectableForActions, pepperiObjectInput?.Data?.Type)"
                    (change)="selectItemForActions($event, pepperiObjectInput?.Data?.UID, pepperiObjectInput?.Data?.IsSelectableForActions, pepperiObjectInput?.Data?.Type)">
                </mat-checkbox>
                <pep-form [firstFieldAsLink]="isCardView ? firstFieldAsLink : false" [checkForChanges]="checkForChanges"
                    [uiControlHeader]="uiControl" [pepperiObjectInput]="pepperiObjectInput" [isCardView]="isCardView"
                    [canEditObject]="!disabled && pepperiObjectInput?.IsEditable" [objectId]="objectId"
                    [parentId]="parentId" [searchCode]="searchCode" [lockEvents]="disableSelectionItems"
                    [layoutType]="getThumbnailsLayout()" [listType]="listType" [isActive]="
                            (pepperiObjectInput?.Data?.UID + SEPARATOR + pepperiObjectInput?.Data?.Type === selectedItemId ||
                                pepperiObjectInput?.Data?.UID + SEPARATOR + pepperiObjectInput?.Data?.Type === hoveredItemId) && !isTouchDevice
                        " (notifyValueChanged)="onValueChanged($event)"
                    (notifyFieldClicked)="onCustomizeFieldClick($event)"
                    (notifyMenuItemClicked)="onCustomizeFieldMenuClicked($event)"
                    (click)="itemClicked($event, pepperiObjectInput)" [pageType]="pageType">
                </pep-form>
            </div>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #listTotals>
    <div *ngIf="totalsRow?.length > 0 && totalsRow.length <= uiControl?.ControlFields.length" class="table-total">
        <fieldset class="table-header-fieldset">
            <div *ngFor="let field of uiControl?.ControlFields; let j = index" class="total-column pull-left flip"
                [ngStyle]="{ width: field.calcTitleColumnWidthString }">
                <label class="total-label body-sm text-align-{{ field.Layout.XAlignment }}">
                    {{ totalsRow[j] }}
                </label>
            </div>
        </fieldset>
    </div>
</ng-template>
